import zoomSdk, { ConfigResponse } from '@zoom/appssdk'

import { useAuthStore } from '@/modules/auth'
import { authApi } from '@/modules/auth/api'

const setAuth = (context: ConfigResponse, authContext: string, isVerifiedZoom: boolean) => {
  useAuthStore.setState({
    context,
    authContext,
    inMeeting: context?.runningContext === 'inMeeting',
    isVerifiedZoom,
  })
}

export const getAuthContext = () => {
  return useAuthStore.getState().authContext
}

export const isVerifiedZoom = () => {
  return useAuthStore.getState().isVerifiedZoom
}

// https://appssdk.zoom.us/index.html
export const getVerifiedZoomContext = async () => {
  try {
    const configResponse = await zoomSdk.config({
      size: { width: 480, height: 360 },
      capabilities: [
        'openUrl',
        'getRunningContext',
        'getMeetingContext',
        'getMeetingParticipants',
        'getUserContext',
        'getMeetingJoinUrl',
        'getMeetingUUID',
        'getAppContext',
        'getMeetingParticipantsEmail',
        'onParticipantChange',
        'onParticipantEmail',
      ],
    })
    const bareContext = (await zoomSdk.getAppContext())?.context
    setAuth(configResponse, bareContext, false)

    const verifiedZoom = await authApi.sendVerifyZoom()

    setAuth(configResponse, bareContext, verifiedZoom.isZoom)
  } catch (e) {
    console.warn('Zoom JS SDK Configuration Error', e)
  }
}
